export default {"src":"/_next/static/media/insurance.83cad961.svg","height":36,"width":36};